var version = {
    "name":      "dativery",
    "buildDateCode": "20251125-124945",
    "buildDate": "Tue Nov 25 2025 12:49:45 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251125-124945",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;